import React from 'react';
import { MxButton } from '@guildeducationinc/playground-mx';
import { ContainerPortal } from '@guildeducationinc/recess';
import styles from './Footer.module.scss';

interface Props {
	disableNext?: boolean;
	onClickPrevious?: () => void;
	onClickNext?: () => void;
}

export const FooterContent: React.FC<Props> = props => (
	<div className={styles.footerContainer}>
		<MxButton
			appearance='ghost'
			onClick={props.onClickPrevious}
			style={{ visibility: props.onClickPrevious ? 'visible' : 'hidden' }}
			testid='quiz-previous'
		>
			Previous
		</MxButton>
		<MxButton
			disabled={props.disableNext}
			onClick={props.onClickNext}
			style={{ visibility: props.onClickNext ? 'visible' : 'hidden' }}
			testid='quiz-next'
		>
			Next
		</MxButton>
	</div>
);

export const Footer: React.FC<Props> = props => (
	<ContainerPortal
		Content={FooterContent}
		containerNode={document.getElementById('quiz-footer')}
		contentProps={props}
	/>
);
